import {PortDeclChunk} from "../../chunks/types/PortDeclChunk";
import {getVarNameFromVarDeclChunk} from "./getVarNameFromVarDeclChunk";

export function getPortNameFromPortDeclChunk(
  portDeclChunk: PortDeclChunk
): string {
  const {
    captures: {
      2: varDeclChunk
    }
  } = portDeclChunk;
  return getVarNameFromVarDeclChunk(varDeclChunk);
}
